import { Middleware } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";

export const hydrateMiddleware: Middleware = () => (next) => (action) => {
  if (action.type === HYDRATE) {
    return next({ ...action, type: "HYDRATE" });
  }
  return next(action);
};
